import React from 'react';

import { useDispatch, useSelector } from "react-redux";

import recoverAction from "~/actions/recover/recoverActions";
import { useTranslation } from "react-i18next";
import Labels from "~/helpers/enums/Labels";
import { Button } from '@material-ui/core';

import TabRecover from '~/components/common/tab/TabMain'
import FormRecover from '~/components/login/recoverPassword/FormRecover'

import { ComeBackIcon } from "~/components/common/icons/Icons";

import './Recover.scss';

const RecoverPassword = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const TABS = [
    {
      id: 0,
      label: t(Labels.RECOVER_PASSWORD_TAB_LABEL2),
      children: (<FormRecover />)
    }
  ]

  return (
      <div className="recoverPass">
          <TabRecover id="TabRecover" tabs={TABS} className={"classMainTabRecover"} />
      </div>
  );
}

export default RecoverPassword;
